import { useEffect } from 'react';
import { useAuthStore } from '../auth/useAuthStore';
import { applySupportWidgetVisibility } from './supportWidgetDom';
import { useSupportWidgetStore } from './useSupportWidgetStore';

/** Syncs body flag so Atlassian JSD widget visibility follows auth + user preference. */
export function SupportWidgetBodyFlag() {
  const authStatus = useAuthStore((s) => s.status);
  const enabled = useSupportWidgetStore((s) => s.enabled);

  useEffect(() => {
    const visible = authStatus === 'authenticated' && enabled;
    applySupportWidgetVisibility(visible);
  }, [authStatus, enabled]);

  useEffect(
    () => () => {
      document.body.setAttribute('data-support-widget', 'false');
    },
    []
  );

  return null;
}
